var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.906241 1.12411L5.15373 6.20704L5.32701 6.41441C5.42926 6.53676 5.46782 6.70647 5.4427 6.86454C5.46782 7.02261 5.42926 7.19231 5.32702 7.31466L5.15373 7.52203L0.906241 12.605L0.732957 12.8123C0.568802 13.0088 0.302653 13.0088 0.138498 12.8123C-0.0256579 12.6159 -0.0256582 12.2974 0.138498 12.1009L0.311781 11.8936L4.51424 6.86454L0.311781 1.83549L0.138498 1.62813C-0.0256579 1.43168 -0.0256579 1.11319 0.138498 0.916742C0.302653 0.720298 0.568802 0.720298 0.732957 0.916742L0.906241 1.12411Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ChevronRight.0c9bcbfd.svg";
export { ForwardRef as ReactComponent };